const SCOPE = 'section-presence-wrapper';

export const SectionPresenceWrapperTestIds = {
  GO_TO_SECTION_BUTTON: `${SCOPE}.go-to-section-button`,
};
